import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/shared/components/app-alert';

@Component({
  selector: 'app-confirm-block-reason',
  templateUrl: './confirm-block-reason.component.html',
  styleUrls: ['./confirm-block-reason.component.sass']
})
export class ConfirmBlockReasonComponent implements AfterViewInit {
  @ViewChild('blockReasonInput') blockReasonInput: ElementRef;

  public message: string = '';
  public blockReason: string = '';

  constructor(
    private modalRef: BsModalRef,
    private alert: AlertService
  ) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.blockReasonInput.nativeElement.focus();
    }, 0);
  }

  confirm(): void {
    if (!this.blockReason) {
      //this.alert.error('The reason should be specified');
      this.blockReasonInput.nativeElement.focus();
      return;
    }
    if (this.modalRef.content.callback != null) {
      this.modalRef.content.callback('yes', this.blockReason);
    }
    this.modalRef.hide();
  }

  decline(): void {
    if (this.modalRef.content.callback != null) {
      this.modalRef.content.callback('no');
    }
    this.modalRef.hide();
  }

}
